var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoutBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner_Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Options",
    className: "premiumIcon",
    transform: "translate(-267.000000, -433.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(189.000000, 433.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(78.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,18.125 C6.12125,18.125 5,17.00375 5,15.625 C5,14.24625 6.12125,13.125 7.5,13.125 C8.87875,13.125 10,14.24625 10,15.625 C10,17.00375 8.87875,18.125 7.5,18.125 M12.26625,0.1375 C12.1175,0.01875 11.9225,-0.02625 11.74,0.015 L0.49,2.515 C0.20375,2.5775 0,2.8325 0,3.125 L0,26.875 C0,27.1675 0.20375,27.42125 0.49,27.485 L11.74,29.985 C11.78375,29.995 11.83,30 11.875,30 C12.01625,30 12.15375,29.9525 12.26625,29.8625 C12.41375,29.74375 12.5,29.565 12.5,29.375 L12.5,0.625 C12.5,0.435 12.41375,0.25625 12.26625,0.1375",
    id: "Fill-4908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875,17.5 C15.83875,17.5 15,16.66125 15,15.625 C15,14.58875 15.83875,13.75 16.875,13.75 L22.5,13.755 L22.5,3.125 C22.5,2.78 22.22,2.5 21.875,2.5 L13.75,2.5 L13.75,27.5 L21.875,27.5 C22.22,27.5 22.5,27.22 22.5,26.875 L22.5,17.505 L16.875,17.5 Z",
    id: "Fill-4909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875,16.249375 L27.86625,16.249375 L23.9325,20.181875 C23.68875,20.425625 23.68875,20.821875 23.9325,21.066875 C24.1775,21.310625 24.5725,21.310625 24.8175,21.066875 L29.8175,16.066875 C30.06125,15.821875 30.06125,15.425625 29.8175,15.181875 L24.8175,10.183125 C24.57375,9.939375 24.1775,9.939375 23.93375,10.183125 C23.68875,10.428125 23.68875,10.823125 23.9325,11.066875 C23.93375,11.068125 26.37,13.504375 27.86625,14.999375 L16.875,14.999375 C16.53,14.999375 16.25,15.279375 16.25,15.624375 C16.25,15.969375 16.53,16.249375 16.875,16.249375",
    id: "Fill-4910"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout_blue.0302ae7a4356837e93696ddf237c01b0.svg";